import { useMutation } from '@tanstack/react-query';

import Banner from 'components/shared/ai/Banner';
import { AIPromptData } from 'models/AIArtifact';
import { createUserResourceView } from 'services/api/userResourceViews';

type ExplainerProps = {
  title: string;
  aiPrompt?: AIPromptData;
  hasBeenCollapsed?: boolean;
  onCollapseSuccess?: () => void;
};

export default function Explainer({ aiPrompt, onCollapseSuccess, ...props }: ExplainerProps) {
  const { mutate } = useMutation({
    mutationFn: createUserResourceView,
    onSuccess: onCollapseSuccess,
  });

  const handleCollapseHeader = () => {
    mutate({
      resourceId: aiPrompt?.id ?? '',
      resourceType: 'AIPrompt',
    });
  };

  return (
    <Banner onCollapseHeader={handleCollapseHeader} {...props}>
      {aiPrompt?.explainer}
    </Banner>
  );
}
